import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  AddIconWhite,
  CloseIcon
} from "../../../../assets/images";
type AppProps = {
  handleBomAddpage: (name: string) => void;
};

const BOMAddModal = ({ handleBomAddpage }: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        // caret
        style={
          toggle
            ? {
                color: "white",
                backgroundColor: "black",
              }
            : {
                color: "white",
                backgroundColor: "#dd4433",
              }
        }
      >
        <img src={AddIconWhite} alt="add_icon" />
        Manufacturing
      </DropdownToggle>

      <DropdownMenu right>
        <div
          className="download-dropdown pr-4 pl-4 pb-4"
          style={{ minWidth: "330px" }}
        >
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0 pt-3 pb-1">
            <h5 className="text-center w-100"></h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="d-flex justify-content-center align-items-center pt-3">
            <span style={{ fontWeight: "600" }}>
              Do you want to select an existing template or start from scratch?
            </span>
          </div>

          <div className="mt-4">
            <button
              className="btn btn-primary mb-2"
              style={{ width: "100%" }}
              onClick={(e: any) => {
                handleBomAddpage("Select from Template");
                setToggle(!toggle);
              }}
            >
              Select from Template
            </button>
            <button
              className="btn btn-primary mb-2"
              style={{ width: "100%" }}
              onClick={(e: any) => {
                handleBomAddpage("Start from Scratch");
                setToggle(!toggle);
              }}
            >
              Start from Scratch
            </button>
          </div>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default BOMAddModal;
